module.exports = __webpack_public_path__ + "media/new/contact-partner-17b520b1.png";